import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/',
)({
  staticData: {
    title: '[graph] - Proposal',
  },
  beforeLoad: () => {
    throw redirect({
      from: '/$account/graphql/$graph/branches/$branch/proposals/$id',
      to: '/$account/graphql/$graph/branches/$branch/proposals/$id/activity',
    })
  },
})
